import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Icon, Input } from "../../components"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* REST API */
import { save } from "../../api/Lead"

/* Widgets */
import { toast } from "../common"

/* Shared */
import { NICHES } from "./shared"

Modal.setAppElement("#root")


/* Widget Lead Form — a lead typed by hand or a change of its words. Opened by the reference:
   this._form.current.open() for a new one, this._form.current.open(lead) for a change.
   Props: cities, onSaved(id), onDuplicate(id) — the phone already stands behind an open lead */
class LeadForm extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            id: null,
            business: "",
            name: "",
            phone: "",
            niche: "",
            cityID: null,
            comment: "",
            saving: false
        }
    }

    open = (lead = null) => {
        this.setState({
            visible: true,
            id: lead ? lead.id : null,
            business: lead && lead.business ? lead.business : "",
            name: lead && lead.name ? lead.name : "",
            phone: lead && lead.phone ? lead.phone : "",
            niche: lead && lead.niche ? lead.niche : "",
            cityID: lead && lead.cityID ? parseInt(lead.cityID) : null,
            comment: lead && lead.comment ? lead.comment : "",
            saving: false
        })
    }

    close = () => {

        if (this.state.saving) {
            return
        }

        this.setState({ visible: false })
    }

    save = () => {

        /* Fields */
        const { id, business, name, phone, niche, cityID, comment, saving } = this.state
        const { onSaved, onDuplicate } = this.props

        if (saving) {
            return
        }

        let valid = true

        if (business.trim().length === 0 && name.trim().length === 0) {
            this._business.error("Название или имя — хоть что-то")
            valid = false
        }

        if (phone.replace(/\D/g, "").length !== 11) {
            this._phone.error("Введите номер целиком")
            valid = false
        }

        if (!valid) {
            return
        }

        this.setState({ saving: true })

        save({ id, business: business.trim(), name: name.trim(), phone, niche, cityID, comment: comment.trim() }).then(response => {

            this.setState({ saving: false })

            if (response && response.status === 200) {
                toast.success(id ? "Сохранено" : "Лид добавлен")
                this.setState({ visible: false })
                onSaved(response.data.id)
                return
            }

            if (response && response.data && response.data.code === "DUPLICATE") {
                this._phone.error("Этот номер уже в воронке")
                if (onDuplicate) {
                    toast.error("Такой лид уже есть — открываю его")
                    this.setState({ visible: false })
                    onDuplicate(response.data.id)
                }
                return
            }

            if (response && response.data && response.data.code === "INVALID_PHONE") {
                this._phone.error("Номер не похож на казахстанский")
                return
            }

            toast.error("Что-то пошло не так! Попробуйте позднее")
        }).catch(() => {
            this.setState({ saving: false })
            toast.error("Что-то пошло не так! Попробуйте позднее")
        })
    }

    render = () => {

        /* Fields */
        const { visible, id, business, name, phone, niche, cityID, comment, saving } = this.state
        const { cities } = this.props

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="wide-modal lead-form"
                overlayClassName="wide-modal-overlay"
                closeTimeoutMS={200}
            >

                <div className="wide-modal-header">
                    <h2>{id ? "Изменить лид" : "Новый лид"}</h2>
                    <div onClick={this.close} className="wide-modal-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                {visible &&
                    <div className="wide-modal-body">

                        <div className="wide-modal-label">Бизнес</div>
                        <Input ref={ref => this._business = ref} label="Название — салон, барбершоп, мойка" maxLength={150} value={business} onChange={event => this.setState({ business: event.target.value })} />

                        <div className="lead-chips">
                            {Object.keys(NICHES).map(key =>
                                <div key={key} onClick={() => this.setState({ niche: niche === key ? "" : key })} className={`lead-chip ${niche === key ? "active" : ""}`}>{NICHES[key]}</div>
                            )}
                        </div>

                        {cities && cities.length > 0 &&
                            <>
                                <div className="wide-modal-label">Город</div>
                                <div className="lead-chips">
                                    {cities.map(city =>
                                        <div key={city.id} onClick={() => this.setState({ cityID: cityID === parseInt(city.id) ? null : parseInt(city.id) })} className={`lead-chip ${cityID === parseInt(city.id) ? "active" : ""}`}>{city.name}</div>
                                    )}
                                </div>
                            </>
                        }

                        <div className="wide-modal-label">Кто на связи</div>
                        <Input label="Имя" maxLength={100} value={name} onChange={event => this.setState({ name: event.target.value })} />
                        <Input mask="+7 (999) 999-99-99" ref={ref => this._phone = ref} label="Телефон" value={phone} onChange={event => this.setState({ phone: event.target.value })} />

                        <div className="wide-modal-label">Что известно</div>
                        <Input textarea rows={3} label="Комментарий — откуда, что важно" maxLength={1000} value={comment} onChange={event => this.setState({ comment: event.target.value })} />

                        {!id &&
                            <div className="admin-form-note">
                                <Icon name="lead" size={16} width={2} />
                                <span>Лид встанет в «Новые», ответственным будете вы. Если номер уже стоит за аккаунтом Pro или точкой — карточка свяжется сама.</span>
                            </div>
                        }

                        <div onClick={this.save} className={`organization-details-button sticky ${saving ? "disabled" : ""}`}>
                            {saving ? <LoadingOutlined /> : (id ? "Сохранить" : "Добавить лид")}
                        </div>

                    </div>
                }

            </Modal>
        )
    }
}

export default LeadForm
